import type { CollabSpaceData } from 'owa-calendar-types';

export function areCollabSpacesEqual(collab1: CollabSpaceData, collab2: CollabSpaceData): boolean {
    return (
        !!collab1 &&
        !!collab2 &&
        collab1.shareLinkInfo?.url === collab2.shareLinkInfo?.url &&
        collab1.isShared === collab2.isShared &&
        collab1.enabled === collab2.enabled &&
        collab1.resourceId === collab2.resourceId
    );
}
